import { render, staticRenderFns } from "./business.vue?vue&type=template&id=0c571f59&scoped=true&"
import script from "./business.vue?vue&type=script&lang=js&"
export * from "./business.vue?vue&type=script&lang=js&"
import style0 from "./business.vue?vue&type=style&index=0&id=0c571f59&prod&lang=scss&scoped=true&"
import style1 from "./business.vue?vue&type=style&index=1&id=0c571f59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c571f59",
  null
  
)

export default component.exports